/*--------------------------------------------------------------------------------------------------------------
 *  Copyright (c) insite-gmbh. All rights reserved.
 *  Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------------------------*/
import { OpaqueToken  } from "@angular/core";

export interface IUserAuthenticationService {
    InvalidUserLevel: string;
    authenticate(username: string, password: string): string;
    isSufficientLevel(currentUserLevel: string, requestedUserLevel: string): boolean;
}

export const IUSERAUTHENTICATIONSERVICE_TOKEN: OpaqueToken = new OpaqueToken('IUserAuthenticationService');